import { cookies } from "@/pages/components/cookies";
import { user } from "@/pages/components/globalstore";
import { retrieveCurrentUrl } from "@/helpers/development";

let url = retrieveCurrentUrl() + "/api/v1";

let headers = {
  Accept: "application/json",
  "Content-type": "application/json;charset=UTF-8",
};

let prepareDataToServer = ({ data }) => {
  // tirando parte do processamento dos dados do back
  if (
    Object.keys(data).includes("NAME") &&
    !Array.isArray(data.NAME) &&
    !Object.keys(data).includes("NUM")
  )
    data.NAME = data.NAME.toUpperCase();
  if (Object.keys(data).includes("LOGIN"))
    data.LOGIN = data.LOGIN.toUpperCase();
  if (
    Object.keys(data).includes("CITY") &&
    Object.keys(data).includes("STATE")
  ) {
    data.CITY = data.CITY.toUpperCase();
    data.STATE = data.STATE.toUpperCase();
  }
  if (Object.keys(data).includes("URL_MAP"))
    data.URL_MAP = data.URL_MAP.toLowerCase();
  return JSON.stringify({ data });
};

let req = (uri, options) => {
  const authToken = cookies.get("authToken");
  if (authToken) options["headers"]["Authorization"] = `Bearer ${authToken}`;
  return fetch(uri, options);
};

function status(res) {
  /* tratamento do retorno feito pelo fetch */
  if (res.status >= 200 && res.status < 300) {
    return Promise.resolve(res);
  } else if ([401, 403].includes(res.status)) {
    user.doLogout();
    window.setTimeout(location.reload(true), 2000);
  }
  return Promise.reject(res.statusText);
}

function json(res) {
  /* tratamento do retorno feito pelo fetch */
  return res.json();
}

const session = {
  validate: (data) =>
    req(`${url}/login-validate`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getFarmsAssociated: (_) =>
    req(`${url}/get-farms-associated`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  addFarmAssociated: (data) =>
    req(`${url}/add-farm-associated`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  editFarmAssociated: (data) =>
    req(`${url}/edit-farm-associated`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  deleteFarmAssociated: (data) =>
    req(`${url}/delete-farm-associated`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getGeneralConfig: (_) =>
    req(`${url}/get-general-config`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  editGeneralConfig: (data) =>
    req(`${url}/edit-general-config`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getAutomationConfig: (_) =>
    req(`${url}/get-automation-config`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  editAutomationConfig: (data) =>
    req(`${url}/edit-automation-config`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getProtocolConfig: (_) =>
    req(`${url}/get-protocol-config`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  editProtocolConfig: (data) =>
    req(`${url}/edit-protocol-config`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getModbusConfig: (_) =>
    req(`${url}/get-modbus-config`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  editModbusConfig: (data) =>
    req(`${url}/edit-modbus-config`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getModbusModels: (_) =>
    req(`${url}/get-modbus-models`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  addModbusModel: (data) =>
    req(`${url}/add-modbus-model`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  editModbusModel: (data) =>
    req(`${url}/edit-modbus-model`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  deleteModbusModel: (data) =>
    req(`${url}/delete-modbus-model`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getI2CConfig: (_) =>
    req(`${url}/get-i2c-config`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  editI2CConfig: (data) =>
    req(`${url}/edit-i2c-config`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getSDI12Config: (_) =>
    req(`${url}/get-sdi12-config`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  editSDI12Config: (data) =>
    req(`${url}/edit-sdi12-config`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getSDI12Models: (_) =>
    req(`${url}/get-sdi12-models`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  addSDI12Model: (data) =>
    req(`${url}/add-sdi12-model`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  editSDI12Model: (data) =>
    req(`${url}/edit-sdi12-model`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  deleteSDI12Model: (data) =>
    req(`${url}/delete-sdi12-model`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getSweepConfig: (_) =>
    req(`${url}/get-sweep-config`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  editSweepConfig: (data) =>
    req(`${url}/edit-sweep-config`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getSweepOverrides: (_) =>
    req(`${url}/get-sweep-overrides`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  addSweepOverride: (data) =>
    req(`${url}/add-sweep-override`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  editSweepOverride: (data) =>
    req(`${url}/edit-sweep-override`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  deleteSweepOverride: (data) =>
    req(`${url}/delete-sweep-override`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getRadioConfig: (_) =>
    req(`${url}/get-radio-config`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  editRadioConfig: (data) =>
    req(`${url}/edit-radio-config`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  logout: (_) =>
    req(`${url}/logout`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

const sweep = {
  statusCir: (_) =>
    req(`${url}/status-cir`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};
const alerts = {
  queryRunner: (data) =>
    req(`${url}/sql`, {
      method: "POST",
      headers,
      body: prepareDataToServer(data),
    })
      .then(status)
      .then(json),
  getAllSensors: (id_user) =>
    req(`${url}/alerts/sensors`, {
      // ?user_id=${id_user}
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  getSensorsRanges: (sensorId) =>
    req(`${url}/alerts/sensors/ranges?sensor_id=${sensorId}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  addSensor: (id_user, data) =>
    req(`${url}/alerts/sensors`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  deleteSensor: (id_user, data) =>
    req(`${url}/alerts/sensors?user_id=${id_user}`, {
      method: "DELETE",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  updateSensor: (id_user, data) =>
    req(`${url}/alerts/sensors?user_id=${id_user}`, {
      method: "PUT",
      headers,
      body: prepareDataToServer(data),
    })
      .then(status)
      .then(json),
  updateSensorRanges: (id_user, data) =>
    req(`${url}/alerts/sensors/ranges?user_id=${id_user}`, {
      method: "PUT",
      headers,
      body: prepareDataToServer(data),
    })
      .then(status)
      .then(json),
  //DIRS
  getAllDirs: (id_user) =>
    req(`${url}/alerts/dir`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  getDirsEmails: (id_user) =>
    req(`${url}/alerts/dir/email`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  addDirEmail: (id_user, data) =>
    req(`${url}/alerts/dir/email`, {
      method: "POST",
      headers,
      body: prepareDataToServer(data),
    })
      .then(status)
      .then(json),
  updateAlertDirs: (id_user, data) =>
    req(`${url}/alerts/dir`, {
      method: "PUT",
      headers,
      body: prepareDataToServer(data),
    })
      .then(status)
      .then(json),
  deleteDirEmail: (id_user, data) => {
    return req(`${url}/alerts/dir/email`, {
      method: "DELETE",
      headers,
      body: prepareDataToServer(data),
    })
      .then(status)
      .then(json);
  },
};

const management = {
  sql: (data) => {
    return req(`${url}/sql`, {
      method: "POST",
      headers,
      body: prepareDataToServer(data),
    })
      .then(status)
      .then(json);
  },
  getManagementSectorsBase: ({ isCroped = false }) => {
    return req(`${url}/management-sectors-base?isCroped=${isCroped}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json);
  },
  getSectorsMonitoringPage: ({ page = 1, limit = 50, isCroped = false }) => {
    return req(`${url}/management-sectors-monitoring?page=${page}&limit=${limit}&isCroped=${isCroped}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json);
  },
  // Sem date (ou hoje) → relatório projetado de hoje (array). Com date passado → histórico gravado
  // daquele dia via rota alternativa ({ date, sectors }). Ver docs/plano_relatorio_diario_por_data.md.
  getManagementDailyReport: (date) => {
    const path = date
      ? `/management-daily-report/by-date?date=${date}`
      : `/management-daily-report`;
    return req(`${url}${path}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json);
  },
  getSectorsMonitoringCounts: () => {
    return req(`${url}/management-sectors-monitoring/counts`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json);
  },
  getSectorsMonitoringSkeleton: ({ type }) => {
    return req(`${url}/management-sectors-monitoring/skeleton?type=${type}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json);
  },
  et0UpdatedStatus: () => {
    return req(`${url}/management/et0-updated-status`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json);
  },
  getDetailsBaseHistory: (bodyData) => {
    return req(`${url}/management/details/base-history`, {
      method: "POST",
      headers,
      body: JSON.stringify(bodyData),
    })
      .then(status)
      .then(json);
  },
  getScheduleManagementRecomentation: (bodyData) => {
    return req(`${url}/schedule/management-recomendation`, {
      method: "POST",
      headers,
      body: JSON.stringify(bodyData),
    })
      .then(status)
      .then(json);
  },
  incrementManagementCycle: ({ idSector }) => {
    return req(`${url}/increment-management-cycle?idSector=${idSector}`, {
      method: "POST",
      headers,
    })
      .then(status)
      .then(json);
  },
  runDaily: () => {
    return req(`${url}/management/run-daily`, {
      method: "POST",
      headers,
    })
      .then(status)
      .then(json);
  },
  recalc: (body = {}) => {
    // headers (global) já tem "Content-type: application/json". NÃO adicionar um segundo
    // "Content-Type": o fetch combina as duas chaves em "application/json;charset=UTF-8,
    // application/json" (inválido), o bodyParser do backend não reconhece e req.body vira {}
    // — o recalc perdia sectorIds/fromDate e caía em "TODOS os setores" (load infinito).
    return req(`${url}/management/recalc`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    })
      .then(status)
      .then(json);
  },
  getFirstEt0Date: () => {
    return req(`${url}/station/first-et0-date`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json);
  },
  // Salva a curva de KC do cultivar (delete + insert atômico no backend) e recalcula os setores
  // associados na mesma requisição. Substitui o delete+insert solto via /sql. Ver §6 do doc de manejo.
  saveFarmDap: (body = {}) => {
    return req(`${url}/management/farm-dap`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    })
      .then(status)
      .then(json);
  },
  // Prévia p/ o modal de exclusão: { [idFarm]: [{ID, NAME}] } com os setores ativos de cada cultivar.
  farmsActiveSectors: (ids) => {
    return req(`${url}/management/farms/active-sectors`, {
      method: "POST",
      headers,
      body: JSON.stringify({ ids }),
    })
      .then(status)
      .then(json);
  },
  // Arquiva (soft-delete) um cultivar. archived:false = travado por setores ativos (activeSectors).
  archiveFarm: (id) => {
    return req(`${url}/management/farm/${id}`, {
      method: "DELETE",
      headers,
    })
      .then(status)
      .then(json);
  },
  // Prévia p/ o modal de exclusão: { [idSoil]: [{ID, NAME}] } com os setores ativos de cada solo.
  soilsActiveSectors: (ids) => {
    return req(`${url}/management/soils/active-sectors`, {
      method: "POST",
      headers,
      body: JSON.stringify({ ids }),
    })
      .then(status)
      .then(json);
  },
  // Arquiva (soft-delete) um solo. archived:false = travado por setores ativos (activeSectors).
  archiveSoil: (id) => {
    return req(`${url}/management/soil/${id}`, {
      method: "DELETE",
      headers,
    })
      .then(status)
      .then(json);
  },

  /*save_volumes: data => fetch(`${url}/volume/save`, {
    method: "POST",
    headers,
    body: JSON.stringify(data)
  })
    .then(status)
    .then(json)
    .catch(err => console.error("[API] - SAVE-VOLUME ", err)),
  save_et0: data => fetch(`${url}/station/save/et0`, {
    method: "POST",
    headers,
    body: JSON.stringify(data)
  })
    .then(status)
    .then(json)
    .catch(err => console.error("[API] - SAVE-ET0 ", err)),
  save_rainfall: data => fetch(`${url}/station/save/rainfall`, {
    method: "POST",
    headers,
    body: JSON.stringify(data)
  })
    .then(status)
    .then(json)
    .catch(err => console.error("[API] - SAVE-RAINFALL ", err)),*/
};
const cmd = {
  reqfw: (data) =>
    req(`${url}/request-firmware-cmd`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  pirFaultAck: (data) =>
    req(`${url}/pir-fault-ack`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  reqofw: (data) =>
    req(`${url}/request-firmware-only-cmd`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  resfw: (data) =>
    req(`${url}/get-firmware-cmd-response`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  schedulechangestate: (data) =>
    req(`${url}/schedule-change-state`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  actuatorsetmode: (data) =>
    req(`${url}/change-valve-mode`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  actuatorsetstate: (data) =>
    req(`${url}/change-valve-state`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  exec: (data) =>
    req(`${url}/exec-cmd`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  dirsyncroute: (data) =>
    req(`${url}/request-sync-route`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  dropfile: (data) =>
    req(`${url}/drop-file`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const info = {
  firmwareInfo: (_) =>
    req(`${url}/get-firmware-info`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  sirVersion: (_) =>
    req(`${url}/get-sir-version`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  fwCirVersion: (_) =>
    req(`${url}/get-fw-cir-version`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  firmwareReleases: (_) =>
    req(`${url}/get-firmware-releases`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  updateFirmware: (data) =>
    req(`${url}/update-firmware`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  uploadFirmware: (formData) =>
    req(`${url}/upload-firmware`, {
      method: "POST",
      headers: { Authorization: null },
      body: formData,
    })
      .then(status)
      .then(json),
};

const logs = {
  uptimeInfo: (_) =>
    req(`${url}/get-uptime-info`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  nodeLogs: (_) =>
    req(`${url}/get-log-node`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  kernelLog: (_) =>
    req(`${url}/get-log-kernel`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  fwLog: (_) =>
    req(`${url}/get-log-fw`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

const network = {
  updateStaticIp: (data) =>
    req(`${url}/update-static-ip`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  updateWifi: (data) =>
    req(`${url}/update-wifi`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  updateRF: (data) =>
    req(`${url}/update-rf-settings`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  networkInfo: (_) =>
    req(`${url}/get-network-info`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  rfInfo: (_) =>
    req(`${url}/get-rf-settings`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  wifiOptions: (_) =>
    req(`${url}/get-wifi-options`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  updateAPI: (data) =>
    req(`${url}/set-api-key`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  apiInfo: (_) =>
    req(`${url}/get-api-key`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

const settings = {
  updateConfigGeneral: (data) =>
    req(`${url}/update-config-general`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  updateDatetimeSettings: (data) =>
    req(`${url}/update-datetime-settings`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  generalSettings: (_) =>
    req(`${url}/get-general-settings`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  systemDate: (_) =>
    req(`${url}/get-datetime-rasp`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

const map = {
  updatePositionInfo: (data) =>
    req(`${url}/update-position-info`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  updateMapURL: (data) =>
    req(`${url}/update-map-url`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  // positionInfo: _ => req(`${url}/get-position-info`),
  positionInfo: (_) =>
    req(`${url}/get-position-info`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  sizekml: (_) =>
    req(`${url}/size-kml`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  mapView: (_) =>
    req(`${url}/map-view`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  kmlImport: (formData) =>
    req(`${url}/kml-import`, {
      method: "POST",
      headers: { Authorization: null },
      body: formData,
    })
      .then(status)
      .then(json),
};

const monitChart = {
  create: (data, controller) =>
    req(`${url}/data-chart`, {
      method: "POST",
      headers,
      signal: controller.signal,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  events: (data, controller) =>
    req(`${url}/data-chart-events`, {
      method: "POST",
      headers,
      signal: controller.signal,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  createEvent: (data) =>
    req(`${url}/data-chart-events-create`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const monit = {
  actuator: (controller) =>
    req(`${url}/get-valve-monitoring`, {
      method: "GET",
      signal: controller.signal,
      headers,
    }).then(status),
  dir: (controller) =>
    req(`${url}/get-dir-monitoring`, {
      method: "GET",
      signal: controller.signal,
      headers,
    }).then(status),
  currentTime: (_) =>
    req(`${url}/current-time`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  sensor: (controller) =>
    req(`${url}/get-sensor-monitoring`, {
      method: "GET",
      signal: controller.signal,
      headers,
    }).then(status),
  sensorPerStation: (controller) =>
    req(`${url}/station-sns-monitoring`, {
      method: "GET",
      signal: controller.signal,
      headers,
      // body: prepareDataToServer({ data })
    })
      .then(status)
      .then(json),
  windrose: (controller) =>
    req(`${url}/windrose`, {
      method: "GET",
      signal: controller.signal,
      headers,
    })
      .then(status)
      .then(json),
  schedule: (controller) =>
    req(`${url}/get-schedule-monitoring`, {
      method: "GET",
      signal: controller.signal,
      headers,
    }).then(status),
  station: () =>
    req(`${url}/get-station-monitoring`, {
      method: "GET",

      headers,
    })
      .then(status)
      .then(json),
  // alert: controller =>
  // req(`${url}/get-alert`, {
  //   method: "GET" ,
  //   signal:controller.signal,
  //   headers
  //   })
  //     .then(json)
};

const chart = {
  listEqpsOpt: (_) =>
    req(`${url}/get-chart-equipments-options`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  // makeChart: data => req(`${url}/create-dual-axe-chart`, {
  makeChart: (data) =>
    req(`${url}/data-chart-dual-Yaxe`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

// const forecast = {
//   get: _ =>
//     req(`${url}/get-forecast-info`, {
//       method: "GET",
//       headers
//     })
//       .then(status)
//       .then(json)
// };

const getAlones = {
  hydro: (_) =>
    req(`${url}/get-alones-hydro-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  pump: (_) =>
    req(`${url}/get-alones-pump-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  modbusPump: (_) =>
    req(`${url}/get-alones-modbus-pump-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  modbusSensor: (_) =>
    req(`${url}/get-alones-modbus-sensor-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  sensor: (_) =>
    req(`${url}/get-alones-sensor-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  pulse: (_) =>
    req(`${url}/get-alones-sensor-pulse-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  onoff: (_) =>
    req(`${url}/get-alones-sensor-onoff-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  emr: (_) =>
    req(`${url}/get-alones-sensor-emr-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  pir: (_) =>
    req(`${url}/get-alones-sensor-pir-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  i2c: (_) =>
    req(`${url}/get-alones-sensor-i2c-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  sdi12: (_) =>
    req(`${url}/get-alones-sensor-sdi12-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  valve: (_) =>
    req(`${url}/get-alones-valve-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

const mtd = {
  list: (_) =>
    req(`${url}/get-mtd-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/mtd-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/mtd-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/mtd-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const dirs = {
  list: (_) =>
    req(`${url}/get-dir-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/dir-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/dir-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/dir-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const firs = {
  config: (data) =>
    req(`${url}/config-fir`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getValves: (_) =>
    req(`${url}/get-ferti-valves`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

const hydros = {
  list: (_) =>
    req(`${url}/get-hydro-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/hydro-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/hydro-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/hydro-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const listEquipments = {
  hydros: (_) =>
    req(`${url}/get-hydro-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  pumps: (_) =>
    req(`${url}/get-pump-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  sensors: (_) =>
    req(`${url}/get-sensor-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  valves: (_) =>
    req(`${url}/get-valve-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  modelsHydro: (_) =>
    req(`${url}/get-model-hydro-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  modelsSensor: (_) =>
    req(`${url}/get-model-sensor-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  modelsValve: (_) =>
    req(`${url}/get-model-valve-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  schedules: (_) =>
    req(`${url}/get-schedule-to-groups`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

const reports = {
  search: (data) => {
    console.log({ data });
    return req(`${url}/report-search`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json);
  },
  getActuators: (controller) =>
    req(`${url}/get-actuators-log-options`, {
      method: "GET",
      headers,
      signal: controller.signal,
    })
      .then(status)
      .then(json),
  getHydroAccVolume: (data) =>
    req(`${url}/acc-volume/hydrometers`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    })
      .then(status)
      .then(json),
  getSensorAccVolume: (data) =>
    req(`${url}/acc-volume/sensors`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    })
      .then(status)
      .then(json),
  getActuatorsBaseReport: ({
    start,
    end,
    elements,
    pickedColumns,
  }) => {
    return req(
      `${url}/actuators-base-report?start=${start}&end=${end}`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({
          elements,
          pickedColumns,
        }),
      }
    )
      .then(status)
      .then(json);
  },
  getSensors: (controller) =>
    req(`${url}/get-sensors-log-options`, {
      method: "GET",
      headers,
      signal: controller.signal,
    })
      .then(status)
      .then(json),
  getDirs: (controller) =>
    req(`${url}/get-dirs-log-options`, {
      method: "GET",
      headers,
      signal: controller.signal,
    })
      .then(status)
      .then(json),
  getHidrometers: (_) =>
    req(`${url}/get-hydro-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  getSensorReport: ({ type, elements, start, end }) =>
    req(`${url}/sensor-report`, {
      method: "POST",
      headers,
      body: JSON.stringify({ type, elements, start, end }),
    })
      .then(status)
      .then(json),
  // Relatórios prontos (1 arquivo HTML por dia) armazenados no CIR — issue #436.
  getDailyReportDates: () =>
    req(`${url}/get-daily-report-dates`, { method: "GET", headers })
      .then(status)
      .then(json),
  getDailyReportContent: (date) =>
    req(`${url}/get-daily-report/${date}`, { method: "GET", headers })
      .then(status)
      .then((res) => res.text()),
  downloadDailyReport: (date) =>
    req(`${url}/get-daily-report/${date}/download`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then((res) => res.blob()),
};

const routes = {
  listPerAddr: (_) =>
    req(`${url}/get-route-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  monitRoutes: (controller) =>
    req(`${url}/get-route-monitoring-list`, {
      method: "GET",
      headers,
      signal: controller.signal,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/route-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/route-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/route-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const schedules = {
  list: (_) =>
    req(`${url}/get-schedule-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/schedule-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/schedule-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/schedule-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getConnecteds: (fertiValve) => {
    if (fertiValve)
      return req(`${url}/connected-valves`, {
        method: "POST",
        headers,
        body: prepareDataToServer({ data: fertiValve }),
      })
        .then(status)
        .then(json);
    else
      return req(`${url}/connected-valves`, {
        method: "GET",
        headers,
      })
        .then(status)
        .then(json);
  },
  getFlows: (_) => {
    return req(`${url}/flow-of-connected-valves`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json);
  },
};

// Agenda própria do PIR (issue #439/#440) -- não reaproveita `schedules`
// (AGN_TIME/AGN_VALVE), que continua atendendo só válvulas comuns.
const pirSchedules = {
  list: (_) =>
    req(`${url}/get-agn-pir-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/agn-pir-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/agn-pir-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/agn-pir-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  toggleActive: (data) =>
    req(`${url}/agn-pir-toggle-active`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  monitoring: (_) =>
    req(`${url}/get-pir-schedule-monitoring`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

// Janela de horário de ponta (config/advanced -- issue #442), singleton
const peakHourConfig = {
  get: (_) =>
    req(`${url}/get-peak-hour-config`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/peak-hour-config-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const peakHourHolidays = {
  list: (_) =>
    req(`${url}/get-peak-hour-holidays-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/peak-hour-holiday-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/peak-hour-holiday-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/peak-hour-holiday-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const sectors = {
  list: (_) =>
    req(`${url}/get-sector-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  basics: (_) =>
    req(`${url}/get-sector-basic-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/sector-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/sector-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/sector-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  hydros: (_) =>
    req(`${url}/get-hydro-selection-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  pumps: (_) =>
    req(`${url}/get-pump-selection-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  sensors: (_) =>
    req(`${url}/get-sensor-selection-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  valves: (_) =>
    req(`${url}/get-valve-selection-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

const sensors = {
  list: (_) =>
    req(`${url}/get-sensor-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/sensor-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/sensor-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/sensor-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const stations = {
  get: (addr) =>
    req(`${url}/get-station-additional-info/${addr}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  config: (data) =>
    req(`${url}/config-station`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  exportData: (data) =>
    req(`${url}/export-station`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getEt0Prediction: ({ start, end }) =>
    req(`${url}/et0-prediction?start=${start}&end=${end}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  calcEt0: ({ from, to, granularity = "daily" }) =>
    req(`${url}/calc-et0?from=${from}&to=${to}&granularity=${granularity}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  chartSensors: () =>
    req(`${url}/station-chart-sensors`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  dataHealth: (days = 14) =>
    req(`${url}/station-data-health?days=${days}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  getStationRead: ({ start, end, readTime }) =>
    req(`${url}/station-read?start=${start}&end=${end}&readTime=${readTime}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  saveManualStationData: (entries) =>
    req(`${url}/save-manual-station-data`, {
      method: "POST",
      headers,
      body: JSON.stringify({ entries }),
    })
      .then(status)
      .then(json),
  getStationManualSeries: ({ from, to }) =>
    req(`${url}/station/manual-series?from=${from}&to=${to}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  getStationManualRecalcPreview: (fromDate, toDate) =>
    req(`${url}/station/manual-recalc-preview?fromDate=${fromDate}${toDate ? `&toDate=${toDate}` : ""}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  getManagementGap: (assume = []) =>
    req(`${url}/station/management-gap${assume.length ? `?assume=${assume.join(",")}` : ""}`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  stationManualRecalc: (fromDate, toDate) =>
    req(`${url}/station/manual-recalc`, {
      method: "POST",
      headers,
      body: JSON.stringify({ fromDate, toDate: toDate || null }),
    })
      .then(status)
      .then(json),
};

const users = {
  list: (_) =>
    req(`${url}/get-user-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/user-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/user-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  getAddonsPermission: () =>
    req(`${url}/addons-permission`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/user-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  changePwd: (data) =>
    req(`${url}/user-password`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  groups: {
    list: (_) =>
      req(`${url}/get-group-list`, {
        method: "GET",
        headers,
      })
        .then(status)
        .then(json),
    relateds: (_) =>
      req(`${url}/get-group-relations`, {
        method: "GET",
        headers,
      })
        .then(status)
        .then(json),
    add: (data) =>
      req(`${url}/group-add`, {
        method: "POST",
        headers,
        body: prepareDataToServer({ data }),
      })
        .then(status)
        .then(json),
    del: (data) =>
      req(`${url}/group-delete`, {
        method: "POST",
        headers,
        body: prepareDataToServer({ data }),
      })
        .then(status)
        .then(json),
    edit: (data) =>
      req(`${url}/group-edit`, {
        method: "POST",
        headers,
        body: prepareDataToServer({ data }),
      })
        .then(status)
        .then(json),
  },
};

const pumps = {
  list: (_) =>
    req(`${url}/get-pump-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/pump-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/pump-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/pump-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const valves = {
  list: (_) =>
    req(`${url}/get-valve-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  getConnecteds: (_) =>
    req(`${url}/connected-valves`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/valve-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/valve-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/valve-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const modelsDir = {
  list: (_) =>
    req(`${url}/get-model-dir-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/model-dir-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/model-dir-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/model-dir-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const modelsHydro = {
  list: (_) =>
    req(`${url}/get-model-hydro-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/model-hydro-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/model-hydro-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/model-hydro-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const modelsSensor = {
  list: (_) =>
    req(`${url}/get-model-sensor-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  types: (_) =>
    req(`${url}/sensor-type-options`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  units: (_) =>
    req(`${url}/get-sensor-unit-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  interfaces: (_) =>
    req(`${url}/get-sensor-interface-options`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  optionsAdd: (data) =>
    req(`${url}/options-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  optionsEdit: (data) =>
    req(`${url}/options-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  optionsDelete: (data) =>
    req(`${url}/options-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/model-sensor-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/model-sensor-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/model-sensor-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

const scripts = {
  get_farms_status: () =>
    req(`${url}/scripts-farms-status`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
};

const modelsValve = {
  list: (_) =>
    req(`${url}/get-model-valve-list`, {
      method: "GET",
      headers,
    })
      .then(status)
      .then(json),
  add: (data) =>
    req(`${url}/model-valve-add`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  del: (data) =>
    req(`${url}/model-valve-delete`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
  edit: (data) =>
    req(`${url}/model-valve-edit`, {
      method: "POST",
      headers,
      body: prepareDataToServer({ data }),
    })
      .then(status)
      .then(json),
};

export {
  alerts,
  management,
  scripts,
  session,
  sweep,
  // gerenciamento & configurações
  cmd,
  info,
  map,
  network,
  logs,
  settings,
  // monitoramento & cadastro
  chart,
  monitChart,
  monit,
  listEquipments,
  getAlones,
  dirs,
  mtd,
  firs,
  // forecast,
  hydros,
  pumps,
  reports,
  routes,
  schedules,
  pirSchedules,
  peakHourConfig,
  peakHourHolidays,
  sectors,
  sensors,
  stations,
  users,
  valves,
  modelsDir,
  modelsHydro,
  modelsSensor,
  modelsValve,
};
